module.exports = __webpack_public_path__ + "img/2009 feuerwehr winteressen 004.23d13b4a.jpg";